export default "/images/ef1456029177bfeebeedd5577ee3b4b8.avif";